import { DRONE_KEYS, type DroneKey } from '@/lib/practice/drone-keys';

const DRONE_KEY_SET = new Set<string>(DRONE_KEYS.map((k) => k.note));

// Flats spell the same pitch as a sharp/natural that exists in the DroneKey
// union. The drone roots on the tonic only, so we normalise to the union's
// spelling and ignore the mode entirely.
const FLAT_TO_DRONE_KEY: Record<string, DroneKey> = {
  Cb: 'B',
  Db: 'C#',
  Eb: 'D#',
  Fb: 'E',
  Gb: 'F#',
  Ab: 'G#',
  Bb: 'A#',
};

const TONIC_PATTERN = /^([A-Ga-g])([#♯b♭]?)/;

function normaliseAccidental(raw: string): string {
  if (raw === '♯') return '#';
  if (raw === '♭') return 'b';
  return raw;
}

export function parseTuneKey(keyName: string | null): DroneKey | null {
  if (keyName === null) return null;

  const match = keyName.trim().match(TONIC_PATTERN);
  if (match === null) return null;

  const letter = match[1].toUpperCase();
  const accidental = normaliseAccidental(match[2]);
  const tonic = `${letter}${accidental}`;

  if (DRONE_KEY_SET.has(tonic)) return tonic as DroneKey;
  return FLAT_TO_DRONE_KEY[tonic] ?? null;
}
